import styled from 'styled-components';

import { rhythm } from "../utils/typography";

export const ArticleMainSec = styled.main`
  flex: 99 3 0;
  padding:0 ${rhythm(0.5)};
  width:100%;
  @media only screen and (max-width: 650px) {
    padding:0 ;
  }
`;


export const ArticleSideSec = styled.div`
    flex: 1 1 10rem;
`;

export const MainSec = styled.div`
  margin: ${rhythm(1.5)} 0;
  margin-top: ${rhythm(3)};
  display: flex; 
  flex-flow: row wrap;
  gap:3ch;
  background:var(--color-background);
  @media only screen and (max-width: 650px) {
    margin: ${rhythm(1.5)} 0;
    margin-top: 0;
  }
  @media only screen and (max-width: 550px) {
    flex-direction:column;
    margin:0;
    margin-top:0};
  }
`;

